import "./App.css";

import CssBaseline from "@material-ui/core/CssBaseline";
import { createAnalytics } from "adapters/analytics";
import { useSyncCurrentLanguage } from "adapters/i18n";
import { PortalRoutes } from "constants/routes";
import ChangePasswordPage from "features/authentication/views/ChangePasswordPage";
import SupplementationRouter from "features/collect/supplementation/views/supplementationRouter";
import HerdControlPage from "features/herdControl/views/herdControlPage";
import PendencyContainer from "features/pendency/views/pendencyContainer";
import UserManagementRouter from "features/userManagement/userManagement.router";
import React, { useEffect } from "react";
import { Router } from "react-router";
import { Route, Switch } from "react-router-dom";
import auth from "../authentication/Auth";
import ForgotPasswordPage from "../authentication/views/ForgotPasswordPage";
import LoginPage from "../authentication/views/LoginPage";
import CollectRouter from "../collect/collectRouter";
import ConfigurationsRouter from "../configurations/configurations.router";
import { FechamentoConsumoContainer } from "../fechamentoConsumo";
import HistoricoMovimentacaoAppContainer from "../historicoMovimentacaoApp/views/historicoMovimentacaoAppContainer";
import ErroBoundary from "../layout/views/erroBoundary";
import Manejo from "../manejo/views/Manejo";
import PaginaInicial from "../paginaInicial";
import TableauContainer from "../tableauEmbedded/views/tableauContainer";
import history from "./History";

const analytics = createAnalytics({});
analytics.initialize();

function App() {
  const isAnalyticsUser = auth.isAnalyticsUser();
  const { syncCurrentAndStoredLanguage } = useSyncCurrentLanguage();

  useEffect(() => {
    syncCurrentAndStoredLanguage();
    // Run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Router history={history}>
      <React.Fragment>
        <CssBaseline />
        {isAnalyticsUser ? <AnalyticsUserRoutes /> : <RegularUserRoutes />}
      </React.Fragment>
    </Router>
  );
}

function AnalyticsUserRoutes() {
  return (
    <Switch>
      <Route exact path={PortalRoutes.HOME} component={TableauContainer} on />
      <Route exact path={PortalRoutes.ANALYTICS} component={TableauContainer} />
    </Switch>
  );
}

function RegularUserRoutes() {
  return (
    <Switch>
      <Route exact path={PortalRoutes.HOME} component={PaginaInicial} />
      <Route path={PortalRoutes.LOGIN} component={LoginPage} on />
      <Route
        path={PortalRoutes.FORGOT_PASSWORD}
        component={ForgotPasswordPage}
      />
      <Route
        path={PortalRoutes.CHANGE_PASSWORD}
        component={ChangePasswordPage}
      />
      <Route exact path={PortalRoutes.ANALYTICS} component={TableauContainer} />
      <Route
        path={PortalRoutes.CONFIGURATIONS}
        // @ts-expect-error: this is intentional since ConfigurationsRouter does not receive route props
        // but since router defined sub-routes, TS infers that it does
        render={(routeProps) => <ConfigurationsRouter {...routeProps} />}
      />
      <Route
        path={PortalRoutes.USER_MANAGEMENT}
        component={UserManagementRouter}
      />
      <Route
        path={PortalRoutes.COLLECTS}
        render={(routeProps) => <CollectRouter {...routeProps} />}
      />
      <Route
        exact
        path={PortalRoutes.CONSUMPTION_CLOSURE}
        component={FechamentoConsumoContainer}
      />
      <Route
        exact
        path={PortalRoutes.SUPPLEMENTATION}
        component={SupplementationRouter}
      />
      <Route
        exact
        path={PortalRoutes.HERD_CONTROL}
        component={HerdControlPage}
      />
      <Route
        exact
        path={PortalRoutes.APP_MOVEMENT_HISTORY}
        component={HistoricoMovimentacaoAppContainer}
      />
      <Route
        path={PortalRoutes.USER_MANAGEMENT}
        // @ts-expect-error: this is intentional since ConfigurationsRouter does not receive route props
        // but since router defined sub-routes, TS infers that it does
        component={(routeProps) => <UserManagementRouter {...routeProps} />}
      />
      <Route
        path={PortalRoutes.PENDING_MOVEMENTS}
        component={PendencyContainer}
      />
      <ErroBoundary>
        <Route exact path="/(\w+)" component={Manejo} />
      </ErroBoundary>
    </Switch>
  );
}

export default App;
